import { render } from "../templates/modal-form.html?vue&type=template&id=6102859c"
import script from "./modal-form.vue?vue&type=script&lang=js"
export * from "./modal-form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__